import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { appAuthenticator, AuthenticatorUser, PROMISE_REQUEST } from '@futrli/shared-services';

import { StoreState } from '../../../core/types';
import { CHANGE_PASSWORD } from '../contants';

/**
 * Changes the user password.
 * @returns {ThunkDispatch<StoreState, unknown, Action>} thunk dispatch function
 */
export const changeUserPassword = (oldPassword: string, newPassword: string) => {
  return async (dispatch: ThunkDispatch<StoreState, unknown, Action>) => {
    const user: AuthenticatorUser = await appAuthenticator.getCurrentAuthenticatedUser();

    /* eslint-disable-next-line @typescript-eslint/await-thenable */
    const data = await dispatch({
      type: CHANGE_PASSWORD.ACTION,
      payload: appAuthenticator.changePassword(user, oldPassword, newPassword),
      meta: {
        flag: PROMISE_REQUEST
      }
    });

    return data;
  };
};
